module.exports = __webpack_public_path__ + "img/logo_blue.08e24c78.png";